import React from 'react'

import Image from '../../../../../components/pdf/Image'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import { COLORS } from '@btime/constants'

// Gap 6 (pedido da Julia Buzzo): header explicitamente ancorado no canto superior
// esquerdo. `Page.js` renderiza este conteúdo dentro de um <th> (thead com
// `table-header-group`, repetido em toda página impressa) — e o estilo padrão do
// navegador para <th> é `text-align: center`, então sem um alinhamento explícito aqui
// o header fica sujeito a herdar essa centralização. Tornamos left/sem margem automática
// explícitos, consistente com a margem 3cm topo/esquerda de `_shared/PageMargins.js`
// (round 3 de #761). Estilo apenas — `Page.js`/`Image.js` (primitivas compartilhadas por
// ~25 marcas) não são tocados.
//
// Seguimento (2º report da Julia Buzzo, mesmo PR): logo aparecendo baixo demais dentro
// do próprio header band. O alinhamento horizontal do Gap 6 só zerava marginLeft/
// marginRight; sem marginTop/marginBottom explícitos, a logo ficava sujeita a herdar
// espaçamento vertical (do <img>/wrapper) em vez de ficar colada no topo da faixa do
// header. Zeramos margin/padding verticais aqui (mesma técnica do Gap 6, agora nos
// eixos vertical), sem alterar `_shared/PageMargins.js` (margem 3cm/2cm/2cm/3cm pedida
// pelo cliente e já confirmada correta por ela) nem `Page.js`/`Image.js`.
const Header = () => (
  <div style={{ textAlign: 'left', width: '100%', margin: 0, padding: 0, verticalAlign: 'top' }}>
    <Image
      src="/pdfs/easysolutions/logo-easysolutions.png"
      maxWidth={200}
      ignoreFixedSize
      style={{ display: 'block', marginTop: 0, marginBottom: 0, marginLeft: 0, marginRight: 'auto' }}
    />
    <LineSeparator weight={4} color={COLORS.light3} padding={6} />
  </div>
)

export default Header
